import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';
import { CountDetailsSearchHandler } from './count-details-search.handler';

@Component({
  selector: 'sym-count-details-search',
  templateUrl: './count-details-search.component.html',
  styleUrls: ['./count-details-search.component.scss'],
})
export class CountDetailsSearchComponent extends CountDetailsSearchHandler implements OnInit {
  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }
}
